import { css } from '@emotion/react';

import theme from 'shared/styles/themes';

export default css({
  '&.submission-form': {},
  '.submission-form': {
    '&__header': {
      justifyContent: 'space-between',
      alignItems: 'center',
      paddingBottom: theme.space[5],
      marginTop: theme.space[4],
    },
    '&__form': {
      position: 'relative',
    },
    '&__divider': {
      marginLeft: '-16px',
      width: 'calc(100% + 32px)',
    },
    '&__label-comment': {
      textTransform: 'uppercase',
    },
    '&__body': {
      flexDirection: 'column',
      paddingTop: theme.space[4],
    },
  },
});
